module.exports = __webpack_public_path__ + "img/read_di.4240bf90.png";